import { useLingui } from "@lingui/react";
import FieldValuePair from "../FieldValuePair.tsx";
import type { SpecProps } from "./types.ts";

export const ModelYear = ({ year }: SpecProps<"year">) => {
  const { i18n } = useLingui();
  if (year == null) {
    return null;
  }

  const yearLabel = i18n._({
    id: "itemPageLayout.common.year",
    message: "Model year",
    comment: "Label for production year in ad section summary",
  });

  return <FieldValuePair field={yearLabel} value={year} />;
};
